import { useState } from "react";
import { motion } from "framer-motion";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
// import img1 from "../../assests/celebration/Pongal/1.jpg";
// import img2 from "../../assests/celebration/Pongal/2.jpg";
// import img3 from "../../assests/celebration/Pongal/3.jpg";
// import img4 from "../../assests/celebration/Pongal/4.jpg";
import img5 from "../../assests/celebration/Pongal/5.jpg";
import img6 from "../../assests/celebration/Pongal/6.jpg";
// import img7 from "../../assests/celebration/Pongal/7.jpg";
// import img8 from "../../assests/celebration/Pongal/8.jpg";
import ay1 from "../../assests/celebration/Ayudha Poojai2024/1.jpg";
import ay2 from "../../assests/celebration/Ayudha Poojai2024/2.jpg";
import ay3 from "../../assests/celebration/Ayudha Poojai2024/3.jpg";
import ay4 from "../../assests/celebration/Ayudha Poojai2024/4.jpg";
import ay5 from "../../assests/celebration/Ayudha Poojai2024/5.jpg";
import ay6 from "../../assests/celebration/Ayudha Poojai2024/6.jpg";
import ay7 from "../../assests/celebration/Ayudha Poojai2024/7.jpg";
import ay8 from "../../assests/celebration/Ayudha Poojai2024/8.jpg";
import ay9 from "../../assests/celebration/Ayudha Poojai2024/9.jpg";
import ay10 from "../../assests/celebration/Ayudha Poojai2024/10.jpg";
import ay11 from "../../assests/celebration/Ayudha Poojai2024/11.jpg";
import ay12 from "../../assests/celebration/Ayudha Poojai2024/12.jpg";
import ay13 from "../../assests/celebration/Ayudha Poojai2024/13.jpg";
import ay14 from "../../assests/celebration/Ayudha Poojai2024/14.jpg";
import ay15 from "../../assests/celebration/Ayudha Poojai2024/15.jpg";
import ay21 from "../../assests/celebration/Ayudhapooja2023/1.jpg";
import ay22 from "../../assests/celebration/Ayudhapooja2023/2.jpg";
import ay23 from "../../assests/celebration/Ayudhapooja2023/3.jpg";
import ay24 from "../../assests/celebration/Ayudhapooja2023/4.jpg";
import team1 from "../../assests/celebration/Team out/1.jpg";
import team2 from "../../assests/celebration/Team out/2.jpg";
import team3 from "../../assests/celebration/Team out/3.jpg";
import team4 from "../../assests/celebration/Team out/4.jpg";
import team5 from "../../assests/celebration/Team out/5.jpg";
import team6 from "../../assests/celebration/Team out/6.jpg";
import team7 from "../../assests/celebration/Team out/7.jpg";
import Ap4 from "../../assests/celebration/Ayudha Pooja -2025/shared image (3).jpeg";
import Ap2 from "../../assests/celebration/Ayudha Pooja -2025/shared image (4).jpeg";
import Ap3 from "../../assests/celebration/Ayudha Pooja -2025/shared image (5).jpeg";
import Ap1 from "../../assests/celebration/Ayudha Pooja -2025/shared image (6).jpeg";
import Ap5 from "../../assests/celebration/Ayudha Pooja -2025/shared image (7).jpeg";
import Ap6 from "../../assests/celebration/Ayudha Pooja -2025/shared image (8).jpeg";
import Ap7 from "../../assests/celebration/Ayudha Pooja -2025/shared image (9).jpeg";
import Ap8 from "../../assests/celebration/Ayudha Pooja -2025/shared image (2).jpeg";
import Ap9 from "../../assests/celebration/Ayudha Pooja -2025/shared image (10).jpeg";
import Ap10 from "../../assests/celebration/Ayudha Pooja -2025/WhatsApp Image 2025-12-19 at 6.16.12 PM.jpeg";
import Ap11 from "../../assests/celebration/Ayudha Pooja -2025/WhatsApp Image 2025-12-19 at 6.16.11 PM.jpeg";
import A12 from "../../assests/celebration/Ayudha Pooja -2025/WhatsApp Image 2025-12-19 at 6.16.08 PM (1).jpeg";
// import Ap13 from "../../assests/celebration/Ayudha Pooja -2025/WhatsApp Image 2025-12-19 at 6.16.08 PM.jpeg";



// Image Data with Multiple Images per Festival
const celebrationImages = [
  { festival: "Ayudha pooja-2023", images: [ay21, ay22, ay23,ay24], description: "We had a wonderful Ayudha Pooja celebration at HikeHealth GS! 🙌 The event was filled with traditional pooja, vibrant decorations, cultural performances, and joyful moments. 🌸🔥Check out our celebration pictures capturing the spirit of gratitude, togetherness, and festivity! 📸🎉" },
  { festival: "Team Out -2024", images: [team1, team2, team3, team4, team5,team6,team7], description: "Our HikeHealth GS team outing was a day full of fun, laughter, and team bonding! From exciting activities to relaxing moments, we created wonderful memories together. 🏞️🌿Check out the pictures capturing our team spirit and amazing moments! 📸✨" },
  { festival: "Ayudha pooja -2024", images: [ay1, ay2, ay3, ay4, ay5, ay6, ay7, ay8, ay9, ay10, ay11,ay12,ay13,ay14,ay15], description: "We had a wonderful Ayudha Pooja celebration at HikeHealth GS! 🙌 with Our School Teacher's. The event was filled with traditional pooja, vibrant decorations, cultural performances, and joyful moments. 🌸🔥Check out our celebration pictures capturing the spirit of gratitude, togetherness, and festivity! 📸🎉" },
  { festival: "Pongal Celebration-2025 ", images: [  img5, img6], description: "HikeHealth GS Pongal Celebration 🌾✨We had an amazing Pongal celebration at HikeHealth GS! 🎉 The event was filled with traditional Pongal cooking, cultural performances, fun games, and festive joy. 🌞🔥Check out our celebration pictures capturing the spirit of togetherness, gratitude, and happiness! 📸🎊" },
  { festival: "Ayudha pooja -2025", images: [  Ap1, Ap2, Ap3, Ap4, Ap5, Ap6, Ap7, Ap8, Ap9, Ap10, Ap11, A12 ], description: "We had an incredible Ayudha Pooja celebration at HikeHealth GS! 🎉 The event was filled with traditional rituals, cultural performances, fun games, and festive joy. 🌸🔧 Check out our celebration pictures capturing the spirit of respect, gratitude, and happiness! 📸🎊"},
  // { festival: "New Year Party 🎊", images: [img5, img6, img1] },
  // { festival: "Independence Day 🇮🇳", images: [img3, img4, img5] },
  // { festival: "Company Annual Day 🎭", images: [img1, img6, img2] },
];

// Custom Arrows
const CustomArrow = ({ onClick, direction }) => (
  <button
      onClick={onClick}
      className={`absolute top-1/2 transform -translate-y-1/2  text-white   bg-gray-400/40 p-3 rounded-full shadow-lg hover:bg-gray-600/90 hover:scale-110 transition-all duration-300 
      ${direction === "left" ? "left-0 ml-2 z-10" : "right-0 mr-2 z-10"} `}
  >
      <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
          className="w-6 h-6 "
      >
          {direction === "left" ? (
              <path
                  fillRule="evenodd"
                  d="M15.707 19.707a1 1 0 0 1-1.414 0l-7-7a1 1 0 0 1 0-1.414l7-7a1 1 0 1 1 1.414 1.414L9.414 12l6.293 6.293a1 1 0 0 1 0 1.414z"
                  clipRule="evenodd"
              />
          ) : (
              <path
                  fillRule="evenodd"
                  d="M8.293 19.707a1 1 0 0 0 1.414 0l7-7a1 1 0 0 0 0-1.414l-7-7a1 1 0 1 0-1.414 1.414L14.586 12l-6.293 6.293a1 1 0 0 0 0 1.414z"
                  clipRule="evenodd"
              />
          )}
      </svg>
  </button>
);
// const CustomPrevArrow = ({ onClick }) => (
//   <div
//     className="absolute left-4 top-1/2 transform -translate-y-1/2 z-10 cursor-pointer text-white 
//                bg-gray-800/70 p-3 rounded-full shadow-lg hover:bg-gray-600/90 hover:scale-110 
//                transition-all duration-300 flex items-center justify-center"
//     onClick={onClick}
//   >
//     <FaArrowLeft size={24} />
//   </div>
// );

// const CustomNextArrow = ({ onClick }) => (
//   <div
//     className="absolute right-4 top-1/2 transform -translate-y-1/2 z-10 cursor-pointer text-white 
//                bg-gray-800/70 p-3 rounded-full shadow-lg hover:bg-gray-600/90 hover:scale-110 
//                transition-all duration-300 flex items-center justify-center"
//     onClick={onClick}
//   >
//     <FaArrowRight size={24} />
//   </div>
// );

const CelebrationGallery = () => {
  const [fullscreenImage, setFullscreenImage] = useState(null);
  const [selectedFestival, setSelectedFestival] = useState(null);
  const [selectedImages, setSelectedImages] = useState([]);
  const [selectedDescription, setSelectedDescription] = useState("");


  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    nextArrow: <CustomArrow direction="left"/>,
    prevArrow: <CustomArrow direction="right" />,
    responsive: [
      { breakpoint: 768, settings: { slidesToShow: 2, slidesToScroll: 1 } },
      { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1 } },
    ],
  };

  return (
    <div className="w-full p-5 bg-gray-200 text-black text-center">
      <h2 className="text-[24px] md:text-[30px] font-semibold text-center bg-gradient-to-r from-[#2a627a] text-gray-800 rounded-xl mb-6">
        HIKEHEALTH GS Celebration Moments
      </h2>

      {/* Main Slider with Enhanced UI */}
      <Slider {...settings} className="w-full">
        {celebrationImages.map((festivalData, index) => (
          <motion.div
            key={index}
            className="relative p-3 cursor-pointer group"
            whileHover={{ scale: 1.1 }}
            onClick={() => {
              setSelectedFestival(festivalData.festival);
              setSelectedImages(festivalData.images);
              setSelectedDescription(festivalData.description);
            }}
          >
            {/* Festival Card */}
            <div className="overflow-hidden rounded-3xl shadow-lg transition-all duration-300 relative">

              {/* Festival Image */}
              <img draggable={false}
                src={festivalData.images[0]}
                alt={festivalData.festival}
                className="w-full h-72 object-cover rounded-3xl transition-all duration-300 group-hover:brightness-75"
              />

              {/* Gradient Overlay & Expanding Text */}
              <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/80 to-transparent rounded-b-3xl transition-all duration-500 h-20 group-hover:h-32 flex flex-col justify-end p-4">

                {/* Festival Name */}
                <p className="text-lg font-semibold text-white tracking-wide transition-all duration-300">
                  {festivalData.festival}
                </p>

                {/* Festival Description (Shows on hover) */}
                <p className="text-sm text-white opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                  {festivalData.description.length > 80
                    ? festivalData.description.substring(0, 80) + "..."
                    : festivalData.description}
                </p>
              </div>
            </div>
          </motion.div>
        ))}
      </Slider>




      {selectedFestival && (
        <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-6 animate-fadeIn">

          {/* Close Button */}
          <button
            className="absolute top-6 right-6 bg-red-500 text-white p-4 rounded-full shadow-lg 
               hover:scale-110 hover:bg-red-600 transition-all duration-300 ring-4 ring-white/20 z-10"
            onClick={() => {
              setSelectedFestival(null);
              setSelectedImages([]);
              setFullscreenImage(null);
            }}
          >
            ✖
          </button>

          {/* Glassmorphic Container */}
          <div className="relative bg-white/10 backdrop-blur-xl p-8 rounded-3xl shadow-2xl 
              max-w-5xl w-full flex flex-col md:flex-row items-center md:items-start 
              space-y-8 md:space-y-0 md:space-x-10 transform scale-95 hover:scale-100 
              transition-all duration-500 border border-white/30">

            {/* Left Side - Festival Title & Description */}
            <div className="w-full md:w-1/2 text-center md:text-left space-y-6">
              <h3 className="text-5xl font-extrabold bg-gradient-to-r from-yellow-400 via-pink-500 to-red-500 
                 text-transparent bg-clip-text drop-shadow-lg animate-slideIn">
                {selectedFestival}
              </h3>
              <p className="text-white text-lg bg-black/40 p-5 rounded-xl shadow-md border border-white/20 animate-fadeIn delay-100">
                {selectedDescription}
              </p>
            </div>

            {/* Right Side - Scrollable Image Gallery */}
            <div
              className="relative w-full md:w-1/2 h-[60vh] overflow-y-auto p-5 rounded-xl shadow-xl 
             bg-white/10 backdrop-blur-lg border border-white/30 animate-slideUp hover:shadow-2xl"
              style={{ scrollbarWidth: "thin", scrollbarColor: "#ffffff40 #00000040" }}
            >
              {/* Custom Scrollbar Styling */}
              <style>
                {`
          ::-webkit-scrollbar { width: 8px; }
          ::-webkit-scrollbar-thumb { background: rgba(255, 255, 255, 0.3); border-radius: 10px; }
          ::-webkit-scrollbar-track { background: transparent; }
        `}
              </style>

              {/* Image List (Vertical Scrolling) */}
              {selectedImages.map((img, idx) => (
                <div
                  key={idx}
                  className="mb-6 transform transition-transform duration-300 hover:scale-105 hover:shadow-lg cursor-pointer"
                  onClick={() => setFullscreenImage(img)} // Open fullscreen view
                >
                 <img draggable={false}
                    src={img}
                    className="w-full object-cover rounded-xl shadow-md hover:shadow-2xl transition-all duration-300"
                    alt={selectedFestival}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      )}


      {/* Fullscreen Image Modal */}
      {fullscreenImage && (
        <div
          className="fixed inset-0 bg-black/90 flex items-center justify-center z-50 p-6 animate-fadeIn"
          onClick={() => setFullscreenImage(null)} // Close when clicking outside
        >
          {/* Close Button */}
          <button
            className="absolute top-6 right-6 bg-red-500 text-white p-4 rounded-full shadow-lg 
               hover:scale-110 hover:bg-red-600 transition-all duration-300"
            onClick={() => setFullscreenImage(null)}
          >
            ✖
          </button>

          {/* Fullscreen Image Container */}
          <div className="relative">
            {/* Image */}
            <img draggable={false}
              src={fullscreenImage}
              className="max-w-[90vw] max-h-[90vh] object-contain rounded-xl shadow-2xl 
                 transition-all duration-300 hover:scale-105 hover:shadow-3xl"
              alt="Fullscreen View"
            />

            {/* Navigation Arrows (Optional) */}
            {selectedImages.length > 1 && (
              <>
                {/* Left Arrow */}
                <button
                  className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-white/20 p-3 rounded-full 
                     shadow-md hover:bg-white/40 transition-all duration-300 text-white"
                  onClick={(e) => {
                    e.stopPropagation();
                    const currentIndex = selectedImages.indexOf(fullscreenImage);
                    const prevIndex = (currentIndex - 1 + selectedImages.length) % selectedImages.length;
                    setFullscreenImage(selectedImages[prevIndex]);
                  }}
                >
                  ◀
                </button>

                {/* Right Arrow */}
                <button
                  className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-white/20 p-3 rounded-full 
                     shadow-md hover:bg-white/40 transition-all duration-300 text-white"
                  onClick={(e) => {
                    e.stopPropagation();
                    const currentIndex = selectedImages.indexOf(fullscreenImage);
                    const nextIndex = (currentIndex + 1) % selectedImages.length;
                    setFullscreenImage(selectedImages[nextIndex]);
                  }}
                >
                  ▶
                </button>
              </>
            )}
          </div>
        </div>
      )}

    </div>
  );
};

export default CelebrationGallery;
